/**
 * Abertura do turno: a contagem inicial da gaveta.
 *
 * Zero é um valor válido e o botão não exige preenchimento — gaveta que começa
 * vazia é decisão da loja, não erro. O que a tela NÃO faz é assumir zero em
 * silêncio: o campo nasce vazio, e quem quiser abrir sem troco digita 0.
 */
import { useState, type FormEvent } from 'react'

import { Botao } from '../../../componentes/Botao'
import { Campo, MensagemDeErro } from '../../../componentes/Campos'
import { Dialogo } from '../../../componentes/Dialogo'
import { analisar, ehValido } from '../../../plataforma/dinheiro'
import { abrirTurno } from '../../../plataforma/caixa'
import { ErroApi } from '../../../plataforma/api'

export function DialogoAbertura({
  aoFechar,
  aoAbrir,
}: {
  aoFechar: () => void
  aoAbrir: () => void
}) {
  const [abertura, setAbertura] = useState('')
  const [terminal, setTerminal] = useState('')
  const [erro, setErro] = useState('')
  const [enviando, setEnviando] = useState(false)

  const aberturaInvalida = abertura.trim() !== '' && !ehValido(abertura)

  async function enviar(evento: FormEvent) {
    evento.preventDefault()
    if (enviando) return

    const centavos = abertura.trim() === '' ? 0 : analisar(abertura)
    if (centavos === null) {
      setErro('Confira o valor da contagem inicial.')
      return
    }

    setEnviando(true)
    setErro('')
    try {
      await abrirTurno({
        abertura_centavos: centavos,
        terminal: terminal.trim() || undefined,
      })
      aoAbrir()
    } catch (falha) {
      setErro(falha instanceof ErroApi ? falha.message : 'Não foi possível abrir o caixa.')
      setEnviando(false)
    }
  }

  return (
    <Dialogo
      titulo="Abrir caixa"
      icone="payments"
      descricao="Conte o dinheiro que já está na gaveta antes da primeira venda. É esse valor que o fechamento vai usar como ponto de partida."
      aoFechar={aoFechar}
    >
      <form onSubmit={enviar} className="flex flex-col gap-4" aria-label="Abrir caixa">
        <Campo
          rotulo="Contagem inicial"
          inputMode="decimal"
          placeholder="0,00"
          value={abertura}
          onChange={(e) => setAbertura(e.target.value)}
          erro={aberturaInvalida ? 'Valor inválido.' : undefined}
          aria-invalid={aberturaInvalida || undefined}
          dica="Deixe em branco ou digite 0 se a gaveta começa vazia."
          autoFocus
        />

        <Campo
          rotulo="Caixa"
          placeholder="Caixa 1"
          value={terminal}
          onChange={(e) => setTerminal(e.target.value)}
          dica="Só é preciso preencher quando a loja tem mais de uma gaveta."
        />

        {erro && <MensagemDeErro>{erro}</MensagemDeErro>}

        <div className="mt-1 flex justify-end gap-2.5">
          <Botao type="button" variante="secundario" porte="medio" onClick={aoFechar}>
            Cancelar
          </Botao>
          <Botao type="submit" porte="medio" disabled={enviando || aberturaInvalida}>
            {enviando ? 'Abrindo…' : 'Abrir caixa'}
          </Botao>
        </div>
      </form>
    </Dialogo>
  )
}
